export const isAikaDomain = (): boolean => {
    const URL = window.location.href

    return URL.includes('.aika.')
}
